import { ReactNode, ButtonHTMLAttributes } from "react";

type Variant = "primary"|"secondary"|"danger"|"ghost"|"outline"|"amber"|"violet";
type Size    = "sm"|"md"|"lg";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?:    Size;
  children: ReactNode;
}

const base = "inline-flex items-center gap-1.5 font-medium rounded-lg transition-opacity disabled:opacity-50 disabled:cursor-not-allowed";
const sizes: Record<Size,    string> = { sm:"text-xs px-3 py-1.5", md:"text-sm px-4 py-2.5", lg:"text-sm px-6 py-3" };
const variants: Record<Variant, string> = {
  primary:  "bg-emerald-600 text-white hover:bg-emerald-700",
  secondary:"bg-slate-100 text-slate-700 hover:bg-slate-200",
  danger:   "bg-red-500 text-white hover:bg-red-600",
  ghost:    "border border-emerald-300 text-emerald-600 hover:bg-emerald-50",
  outline:  "border border-slate-300 text-slate-600 hover:bg-slate-50",
  amber:    "bg-amber-500 text-white hover:bg-amber-600",
  violet:   "bg-violet-600 text-white hover:bg-violet-700",
};

export default function Button({ variant="primary", size="md", className="", children, ...rest }: Props) {
  return (
    <button className={`${base} ${sizes[size]} ${variants[variant]} ${className}`} {...rest}>
      {children}
    </button>
  );
}
